import { createI18n } from "vue-i18n";

import de from "../lang/de.json";

const messages = {
  de: de,
};

const i18n = createI18n({
  locale: "de", // Set the default locale
  fallbackLocale: "de",
    fallbackWarn: false,
    missingWarn: false,
  messages,
});

export default i18n;
